import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stepper,
  Step,
  StepLabel,
  Box,
} from "@mui/material";
import { Fade, Slide } from "@mui/material";
import ConnectWebsiteStep from "./website/ConnectWebsiteStep";
import EndpointStep from "./website/EndpointStep";
import FormMappingStep from "./website/FormMappingStep";
import TestActivateStep from "./website/TestActivateStep";

const steps = [
  "Website Details",
  "API Endpoint",
  "Field Mapping",
  "Test & Activate",
];

const WebsiteIntegrationModal = ({ open, onClose }) => {
  const [step, setStep] = useState(0);
  const [direction, setDirection] = useState("left");

  const [website, setWebsite] = useState({
    name: "",
    url: "",
    endpointId: "ws_" + Math.floor(Math.random() * 100000),
    secret: Math.random().toString(36).slice(2),
  });

  const handleNext = () => {
    if (step < steps.length - 1) setStep(step + 1);
    else onClose();
  };

  const handleBack = () => setStep(step - 1);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          fontSize: "1.1rem",
          pb: 1,
        }}
      >
        Website Integration
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          pt: 2,
          pb: 3,
        }}
      >
        <Stepper
          activeStep={step}
          alternativeLabel
          sx={{
            mb: 4,
            "& .MuiStepLabel-label": {
              fontSize: "0.8rem",
            },
          }}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box sx={{ minHeight: 260, position: "relative", overflow: "hidden" }}>
          <Slide direction={direction} in key={step} timeout={450}>
            <Fade in timeout={550}>
              <Box>
                {step === 0 && (
                  <ConnectWebsiteStep
                    website={website}
                    setWebsite={setWebsite}
                  />
                )}
                {step === 1 && <EndpointStep website={website} />}
                {step === 2 && <FormMappingStep />}
                {step === 3 && <TestActivateStep />}
              </Box>
            </Fade>
          </Slide>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2,
        }}
      >
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>

        {step > 0 && (
          <Button onClick={handleBack} color="inherit">
            Back
          </Button>
        )}

        <Button
          variant="contained"
          onClick={handleNext}
          sx={{ borderRadius: 2, px: 3 }}
        >
          {step === steps.length - 1 ? "Activate" : "Next"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WebsiteIntegrationModal;
